<template>
	<Tooltip placement="topLeft" color="black">
		<template #title>{{ $t('base-stations-edit.tooltips.mntpntInt') }}</template>
		<QuestionCircleOutlined /> {{ $t('base-stations-edit.fields.mntpntInt') }}
	</Tooltip>
</template>

<script>
import { Tooltip } from 'ant-design-vue';

import { QuestionCircleOutlined } from '@ant-design/icons-vue';


export default {
	components: { Tooltip, QuestionCircleOutlined },
}
</script>
